module.exports = __webpack_public_path__ + "img/menu_dots.7e5cca29.svg";